import { render, staticRenderFns } from "./integralSetting.vue?vue&type=template&id=1b983e53&scoped=true&"
import script from "./integralSetting.vue?vue&type=script&lang=js&"
export * from "./integralSetting.vue?vue&type=script&lang=js&"
import style0 from "./integralSetting.vue?vue&type=style&index=0&id=1b983e53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b983e53",
  null
  
)

export default component.exports